/**
 * Inicializa el minicart personalizado del tema.
 *
 * WooCommerce se encarga de actualizar mediante AJAX:
 *
 * - El contador de productos.
 * - El contenido del minicart.
 *
 * Este módulo se encarga principalmente de:
 *
 * - Abrir el drawer.
 * - Cerrarlo.
 * - Cerrar al hacer click fuera.
 * - Cerrar con Escape.
 */
export function initMiniCart() {

    // --------------------------------------------------
    // Elementos principales
    // --------------------------------------------------

    const cartButton = document.querySelector('.my-cart-icon');

    const cartDrawer = document.querySelector('#cart-drawer');

    // Si el carrito no existe en esta página,
    // no necesitamos inicializar nada.
    if (!cartButton || !cartDrawer) {
        return;
    }

    // Botón "X" para cerrar el minicart.
    const closeButton = cartDrawer.querySelector('.cart-drawer-close');

    // Overlay que cubre el resto de la página.
    const overlay = cartDrawer.querySelector('.cart-drawer-overlay');

    // Contenido interno del drawer.
    const cartContent = cartDrawer.querySelector('.cart-drawer-content');


    // --------------------------------------------------
    // Abrir minicart
    // --------------------------------------------------

    const openCart = () => {

        cartDrawer.classList.add('is-open');

        document.body.classList.add('cart-drawer-open');

    };


    // --------------------------------------------------
    // Cerrar minicart
    // --------------------------------------------------

    const closeCart = () => {

        cartDrawer.classList.remove('is-open');

        document.body.classList.remove('cart-drawer-open');

    };


    // --------------------------------------------------
    // Eventos del minicart
    // --------------------------------------------------

    // Abrir al hacer click en el icono del carrito.
    cartButton.addEventListener('click', openCart);

    // Cerrar con el botón X.
    closeButton?.addEventListener('click', closeCart);

    // Cerrar haciendo click en el overlay.
    overlay?.addEventListener('click', closeCart);


    // --------------------------------------------------
    // Cerrar haciendo click fuera
    // --------------------------------------------------

    document.addEventListener('click', (event) => {

        // Si está cerrado, no hacemos nada.
        if (!cartDrawer.classList.contains('is-open')) {
            return;
        }

        const target = event.target;

        // Click dentro del drawer:
        // no debemos cerrarlo.
        if (cartContent?.contains(target)) {
            return;
        }

        // Click en el botón del carrito:
        // tampoco debemos cerrarlo aquí.
        if (cartButton.contains(target)) {
            return;
        }

        // Cualquier otro click cierra el drawer.
        closeCart();

    });


    // --------------------------------------------------
    // Cerrar con Escape
    // --------------------------------------------------

    document.addEventListener('keydown', (event) => {

        if (
            event.key === 'Escape' &&
            cartDrawer.classList.contains('is-open')
        ) {
            closeCart();
        }

    });


    // --------------------------------------------------
    // WooCommerce AJAX
    // --------------------------------------------------

    /**
     * Se dispara después de que WooCommerce agrega
     * correctamente un producto al carrito mediante AJAX.
     *
     * Los fragments ya fueron actualizados por WooCommerce.
     *
     * Por ahora abrimos automáticamente el minicart.
     */
    jQuery(document.body).on('added_to_cart', () => {

        openCart();

    });

}